<ap-section-header>
  <ap-section-header-grid
    [iconId]="'ap-icon-fields'"
    [caption]="caption"
    [filterPlaceholder]="filter"
    [filterTooltip]="caption"
    [canCreate]="false"
    (clearAllFilters)="clearFilters()"
    (search)="performSearch($event)"
  ></ap-section-header-grid>
</ap-section-header>
<ap-crop-rotation-grid [items]="items$ | async"
                       [loading]="loading$ | async"
                       [saving]="saving$ | async"
                       [availableCropTypes]="cropTypes"
                       [allCropTypes]="allCropTypes"
                       [currentYear]="currentYear"
                       [yearInterval]="[-1, 0, 1]"
                       [sidebarChange$]="menuMode$"
                       [mapViewChange$]="mapViewMode$"
                       [numericRound]="settings?.DigitsAfterDecimalPoint"
                       [searchText]="searchText$"
                       (selectedItems)="onSelectedItem($event)"
                       (saveCell)="onSaveCell($event)"
                       (getFocus)="onCellGetFocus($event)"
                       (lostFocus)="onCellLostFocus($event)"
                       (massEditChange)="onMassEditChange($event)"
                       (massEditRemoveMainCrop)="onMassEditRemoveMainCrop($event)"
                       [clearAllFilters]="clearAllFilters$"
                       (massEditRemoveSecondCrop)="onMassEditRemoveSecondCrop($event)"
></ap-crop-rotation-grid>
